/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * validates if the current page is the customer-service one
 */
export const isCustomerServiceRoute = (location) => {
    const customerServicePaths = ['/customer-service', '/customerservice', '/customerserv', '/custserv'];
    return customerServicePaths.filter((r) => location.pathname.includes(r)).length > 0;
};

export const parseBannerCodes = (bannerCodesAttempted) => {
    let bannerCodes = '';
    if (bannerCodesAttempted?.length) {
        bannerCodesAttempted.map((bannerCode, index) => {
            bannerCodes += `${bannerCode.promoCode}`;
            if (bannerCodesAttempted.length - 1 > index) {
                bannerCodes += ',';
            }
        });
    }

    return { bannerCodes, bannerCodesAttemptCount: bannerCodesAttempted?.length };
};
export const nodeToString = (node) => {
    if (node?.type === 'text') {
        return node?.data;
    }
    if (node?.type === 'tag') {
        const childrenString = node?.children?.map(nodeToString)?.join('');
        // eslint-disable-next-line prefer-template
        return `<${node?.name}${node?.attribs ? ' ' + Object.entries(node?.attribs).map(([key, value]) => `${key}="${value}"`).join(' ') : ''}>${childrenString}</${node?.name}>`;
    }
    return '';
};
export default { isCustomerServiceRoute };
